import { useState, useEffect, useRef, useMemo } from 'react'
type durationType = 'Yearly' | 'Monthly'

const useDropdown = () => {
    const [duration, setDuration] = useState<durationType>('Yearly')
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const dropdownRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    const handleDurationDropdown = (period: durationType) => {
        console.log('Propagating duration change:', period);
        setDuration(period)
        setIsOpen(false)
    }
    const toggleDropdown = () => {
        setIsOpen((prev) => !prev)
    }

    return { duration, isOpen, dropdownRef,toggleDropdown, handleDurationDropdown };
}
export default useDropdown
